export { default } from './Footer.jsx';
